export default "__VITE_ASSET__rZD3hyDN__"